<template>
  <div class="product-grid-wrapper">
    <div class="product-grid">
      <Product
        v-for="product in arrProducts"
        :key="product.id"
        :id="product.id"
        :name="product.name"
        :photo="product.featured_image"
        :productType="product.product_type"
        :displayPrice="product.display_price"
        :displayStock="product.display_stock"
        :isStockTracked="product.is_stock_tracked"
        :isOutOfStock="product.is_out_of_stock"
        :isAcceptingOrders="product.is_accepting_orders"
        :isShippable="product.shippable"
        :isForPickup="product.is_for_school_pickup"
      >
      </Product>
    </div>
  </div>
</template>

<script>
import Product from "@/modules/shop/components/Product.vue";
export default {
  components: {
    Product
  },
  data() {
    return {};
  },
  props: {
    arrProducts: {
      type: Array,
      required: true
    }
  }
};
</script>
